import {
  Component,
  EventEmitter,
  Input,
  Output,
  forwardRef,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { EoBaseFormControlComponent } from '../eo-base-form-control/eo-base-form-control.component';
import { IEoDropdownConfig } from './eo-dropdown.model';
@Component({
  selector: 'eo-dropdown',
  templateUrl: './eo-dropdown.component.html',
  styleUrl: './eo-dropdown.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EoDropdownComponent),
      multi: true,
    },
  ],
})
export class EoDropdownComponent<T> extends EoBaseFormControlComponent {
  protected override _config?: IEoDropdownConfig<T>;

  override get config() {
    return this._config;
  }
  override set config(val: IEoDropdownConfig<T> | undefined) {
    this._config = val;
  }

  @Input() dropdownIcon?: string;
  @Input() inputStyleClass?: string;
  @Input() optionLabel?: string;
  @Input() optionValue?: string;
  @Input() options?: T[];
  @Input() dropdownStyleClass?: string;
  @Input() placeholder?: string;
  @Input() loadingPlaceholder?: string;
  @Input() showClear: boolean | null = null;
  @Input() filter = false;
  @Input() group = false;
  @Input() filterBy?: string;
  @Input() filterFields?: any[];
  @Input() filterPlaceholder?: string;
  @Input() appendTo?: any;

  @Input() virtualScrollSize?: number;
  @Input() virtualScroll: boolean = false;
  @Input() override loading = false;

  @Output() onFilter: EventEmitter<any> = new EventEmitter();

  protected hasInputIcon(): boolean {
    return this.dropdownIcon != null || this.config?.inputIcon != null;
  }
  protected getDropdownIcon(): string {
    if (this.loading) return 'pi pi-spinner pi-spin';
    return this.dropdownIcon ?? this.config?.inputIcon ?? 'pi pi-chevron-down';
  }
  protected getPlaceholder(): string {
    if (this.loading)
      return this.loadingPlaceholder ?? this.config?.loadingPlaceholder ?? '';

    return this.placeholder ?? this.config?.placeholder ?? '';
  }
  protected getInputStyleClass(): string {
    return this.inputStyleClass ?? this.config?.inputStyleClass ?? '';
  }
  protected getOptionLabel(): string {
    return this.optionLabel ?? this.config?.optionLabel ?? '';
  }
  protected getOptionValue(): string {
    return this.optionValue ?? this.config?.optionValue ?? '';
  }
  protected getOptions(): T[] {
    return this.options ?? this.config?.options ?? [];
  }
  protected getDropdownStyleClass(): string {
    return this.dropdownStyleClass ?? this.config?.dropdownStyleClass ?? '';
  }
  protected getLoadingPlaceholder(): string {
    return this.loadingPlaceholder ?? this.config?.loadingPlaceholder ?? '';
  }
  protected getShowClear(): boolean {
    return this.showClear ?? this.config?.showClear ?? false;
  }
  protected hasFilter(): boolean {
    return this.filter ?? this.config?.filter ?? false;
  }
  protected getFilterBy(): string {
    return this.filterBy ?? this.config?.filterBy ?? '';
  }
  protected getFilterFields(): any[] {
    return this.filterFields ?? this.config?.filterFields ?? [];
  }
  protected getFilterPlaceholder(): string {
    return this.filterPlaceholder ?? this.config?.filterPlaceholder ?? '';
  }
  protected getAppendTo(): any {
    return this.appendTo ?? this.config?.appendTo ?? '';
  }
  protected getGroup(): boolean {
    return this.group ?? this.config?.group ?? false;
  }

  protected getVirtualScrollSize(): number {
    return this.virtualScrollSize ?? this.config?.virtualScrollSize ?? 0;
  }

  protected getVirtualScroll(): boolean {
    return this.virtualScroll ?? this.config?.virtualScroll ?? false;
  }
}
